define(
	'C3.ShoppingExtensions.Media.Macro.View',
	[
		    'SCView'
		,   'media_macro_view.tpl'
		,   'AjaxRequestsKiller'
		,   'Utils'
		],
	function(
		   SCViewComponent
		,  media_macro_view_tpl
		,   AjaxRequestsKiller
		,   Utils
		) {
		'use strict';

		var SCView = SCViewComponent.SCView;

		function ResourcesMacroView(options) {
			SCView.call(this);

			//console.log(options)

			this.options = options || {};

			this.template = media_macro_view_tpl;	
			this.model = options.model;
			this.application = options.application;
		}

		// Inherit parent instance methods.
		ResourcesMacroView.prototype = Object.create(SCView.prototype);

		// Restore the constuctor.
		ResourcesMacroView.prototype.constructor = ResourcesMacroView;

		ResourcesMacroView.prototype.getContext = function() {
			
			return {
				value : this.model.get('value'),
				isPhoneDevice : Utils.isPhoneDevice()
			};
		}

		return ResourcesMacroView;
	}

);
